import React from 'react';
import {RouteProps} from 'react-router-dom';

export const RouteChildren = ({children}: RouteProps) => <>{children}</>;
